import React from 'react';
import { Button } from '../../ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../../ui/card';
import { Textarea } from '../../ui/textarea';
import { StickyNote, Plus, Trash2 } from 'lucide-react';
import { COMPANY } from '../../../config/company';

const LeadNotesTab = ({
  language,
  lead,
  newNote,
  setNewNote,
  addNote,
  deleteNote
}) => {
  return (
    <Card data-testid="lead-notes-tab">
      <CardHeader style={{ backgroundColor: COMPANY.primaryColor }} className="text-white rounded-t-lg">
        <CardTitle className="flex items-center">
          <StickyNote className="mr-2 h-5 w-5" />
          {language === 'es' ? 'Notas' : 'Notes'}
        </CardTitle>
      </CardHeader>
      <CardContent className="pt-6">
        <div className="flex gap-2 mb-4">
          <Textarea 
            placeholder={language === 'es' ? 'Agregar una nota...' : 'Add a note...'} 
            value={newNote} 
            onChange={(e) => setNewNote(e.target.value)} 
            rows={2} 
            className="flex-1" 
            data-testid="new-note-textarea"
          />
          <Button 
            onClick={addNote} 
            style={{ backgroundColor: COMPANY.primaryColor }} 
            className="text-white self-end"
            data-testid="add-note-btn"
          >
            <Plus className="h-4 w-4" />
          </Button>
        </div>
        <div className="space-y-2 max-h-96 overflow-y-auto">
          {(lead.notes || []).map((note) => (
            <div key={note.id} className="bg-yellow-50 border border-yellow-200 rounded-lg p-3">
              <div className="flex justify-between items-start">
                <p className="text-sm text-gray-700 flex-1">{note.content}</p>
                <Button 
                  size="sm" 
                  variant="ghost" 
                  className="text-red-400 hover:text-red-600 h-6 w-6 p-0" 
                  onClick={() => deleteNote(note.id)}
                >
                  <Trash2 className="h-3 w-3" />
                </Button>
              </div>
              <p className="text-xs text-gray-400 mt-1">{new Date(note.created_at).toLocaleString()}</p>
            </div>
          ))}
          {(!lead.notes || lead.notes.length === 0) && (
            <p className="text-gray-400 text-center py-4 text-sm">
              {language === 'es' ? 'Sin notas' : 'No notes yet'}
            </p>
          )}
        </div>
      </CardContent>
    </Card>
  );
};

export default LeadNotesTab;
